export default __webpack_public_path__ + "static/media/comments.88080b68.png";